import * as ACTIONS from 'constants/action_types';
import { handleActions } from 'util/redux-utils';
const deleteIds = (list, ids) => {
  return list.filter((n) => !ids.includes(n.id));
};

const markIdsAsRead = (list, ids) => {
  return (
    list &&
    list.map((n) => {
      if (ids.includes(n.id)) {
        return { ...n, is_read: true };
      } else {
        return { ...n };
      }
    })
  );
};

const markIdsAsSeen = (list, ids) => {
  return list.map((n) => {
    if (ids.includes(n.id)) {
      return { ...n, is_seen: true };
    }

    return n;
  });
};

const deleteId = (list, id) => {
  return list.filter((n) => n.id !== id);
};

const defaultState = {
  notifications: [],
  notificationsFiltered: [],
  deletedNotificationIds: [],
  notificationCategories: undefined,
  fetchingNotifications: false,
  toasts: [],
  errors: [],
  nagIds: [],
  debugLog: [],
};
export default handleActions(
  {
    // Toasts
    [ACTIONS.CREATE_TOAST]: (state: NotificationState, action: any) => {
      const toast: Toast = action.data;
      const newToasts: Array<Toast> = state.toasts.slice();
      newToasts.push(toast);
      return { ...state, toasts: newToasts };
    },
    [ACTIONS.DISMISS_TOAST]: (state: NotificationState) => {
      const newToasts: Array<Toast> = state.toasts.slice();
      newToasts.pop();
      return { ...state, toasts: newToasts };
    },
    // Debug Log
    [ACTIONS.DEBUG_LOG]: (state: NotificationState, action: any) => {
      const { clear, append, info } = action.data;
      const debugLog = append ? state.debugLog.slice() : [];

      if (!clear && info) {
        debugLog.splice(0, 0, info);
      }

      return { ...state, debugLog };
    },
    // Notifications
    [ACTIONS.NOTIFICATION_LIST_STARTED]: (state, action) => {
      return { ...state, fetchingNotifications: true };
    },
    [ACTIONS.NOTIFICATION_LIST_COMPLETED]: (state, action) => {
      const { deletedNotificationIds } = state;
      const { filterRule, newNotifications } = action.data;

      if (filterRule) {
        return {
          ...state,
          notificationsFiltered: deleteIds(newNotifications, deletedNotificationIds),
          fetchingNotifications: false,
        };
      } else {
        return {
          ...state,
          notifications: deleteIds(newNotifications, deletedNotificationIds),
          fetchingNotifications: false,
        };
      }
    },
    [ACTIONS.NOTIFICATION_LIST_FAILED]: (state, action) => {
      return { ...state, fetchingNotifications: false };
    },
    [ACTIONS.NOTIFICATION_CATEGORIES_COMPLETED]: (state, action) => {
      const { notificationCategories } = action.data;
      return { ...state, notificationCategories };
    },
    [ACTIONS.NOTIFICATION_READ_COMPLETED]: (state, action) => {
      const { notifications, notificationsFiltered } = state;
      const { notificationIds } = action.data;

      return {
        ...state,
        notifications: markIdsAsRead(notifications, notificationIds),
        notificationsFiltered: markIdsAsRead(notificationsFiltered, notificationIds),
      };
    },
    [ACTIONS.NOTIFICATION_READ_FAILED]: (state, action) => {
      return { ...state };
    },
    [ACTIONS.NOTIFICATION_SEEN_COMPLETED]: (state, action) => {
      const { notifications, notificationsFiltered } = state;
      const { notificationIds } = action.data;

      return {
        ...state,
        notifications: markIdsAsSeen(notifications, notificationIds),
        notificationsFiltered: markIdsAsSeen(notificationsFiltered, notificationIds),
      };
    },
    [ACTIONS.NOTIFICATION_DELETE_COMPLETED]: (state, action) => {
      const { notifications, notificationsFiltered, deletedNotificationIds } = state;
      const { notificationId } = action.data;

      return {
        ...state,
        notifications: deleteId(notifications, notificationId),
        notificationsFiltered: deleteId(notificationsFiltered, notificationId),
        deletedNotificationIds: deletedNotificationIds.concat(notificationId),
      };
    },
    // Errors
    [ACTIONS.CREATE_ERROR]: (state: NotificationState, action: any) => {
      const error: ErrorNotification = action.data;
      const newErrors: Array<ErrorNotification> = state.errors.slice();
      newErrors.push(error);
      return { ...state, errors: newErrors };
    },
    [ACTIONS.DISMISS_ERROR]: (state: NotificationState) => {
      const newErrors: Array<ErrorNotification> = state.errors.slice();
      newErrors.shift();
      return { ...state, errors: newErrors };
    },
    [ACTIONS.NAG_SHOWN]: (state: NotificationState, action: any) => {
      const id = action.data;

      if (!state.nagIds.includes(id)) {
        const nagIds = state.nagIds.slice();
        nagIds.push(id);
        return { ...state, nagIds };
      } else {
        return state;
      }
    },
    [ACTIONS.NAG_DISMISSED]: (state: NotificationState, action: any) => {
      const id = action.data;

      if (state.nagIds.includes(id)) {
        return { ...state, nagIds: state.nagIds.filter((x) => x !== id) };
      } else {
        return state;
      }
    },
  },
  defaultState
);
